'use client';

import { c as _c } from "react/compiler-runtime";
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import Gradient_4_mob from '@images/gradients/gradient_4_mob.webp';
import Gradient_5 from '@images/gradients/gradient_5.webp';
import SVGrRight from '@images/renders/infrastructure_images/Default.svg';
import { scrollLocation } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useViewport } from '@lib/tools/hooks/useViewport';
import classNames from 'classnames';
import NextImage from 'next/image';
import { useCallback, useEffect, useRef, useState } from 'react';
import style from './SliderLocation.module.scss';
function SliderLocation() {
  const $ = _c(40);
  const [translate, setTranslate] = useState(-150);
  const [rotateN, setRotaten] = useState(0);
  const scrollRef = useRef(null);
  const activeRef = useRef(null);
  const wrapperRef = useRef(null);
  const wrapperNextRef = useRef(null);
  const wrapperPrevRef = useRef(null);
  const cursorNext = useRef(null);
  const cursorPrev = useRef(null);
  const [maxOffset2, setMaxOffset2] = useState(0);
  const {
    isMobile
  } = useViewport();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (e, cursorRef) => {
      if (!cursorRef.current || !scrollRef.current) {
        return;
      }
      const containerRect = scrollRef.current.getBoundingClientRect();
      const x = e.clientX - containerRect.left;
      const y = e.clientY - containerRect.top;
      cursorRef.current.style.transform = `translate(${x - 68}px, ${y - 68}px)`;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const moveCursor = t0;
  const showCursor = _temp;
  const hideCursor = _temp2;
  let t1;
  if ($[1] !== maxOffset2 || $[2] !== translate) {
    t1 = () => {
      setTranslate(Math.max(-maxOffset2, translate - wrapperRef?.current?.getBoundingClientRect().width * 0.2));
    };
    $[1] = maxOffset2;
    $[2] = translate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const GoToLeft = t1;
  let t2;
  if ($[4] !== maxOffset2 || $[5] !== translate) {
    t2 = () => {
      setTranslate(translate <= -maxOffset2 ? translate + wrapperRef?.current?.getBoundingClientRect().width * 0.2 : 0);
    };
    $[4] = maxOffset2;
    $[5] = translate;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const GoToRight = t2;
  let t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const calculateMaxOffset = () => {
        if (wrapperRef.current && typeof window !== "undefined") {
          const offset = wrapperRef.current.getBoundingClientRect().width - window.innerWidth;
          setMaxOffset2(offset);
        }
      };
      calculateMaxOffset();
      if (typeof window !== "undefined") {
        window.addEventListener("resize", calculateMaxOffset);
      }
      return () => window.removeEventListener("resize", calculateMaxOffset);
    };
    t4 = [];
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      if (wrapperRef) {
        setTranslate(-(wrapperRef.current.getBoundingClientRect().width * 0.2));
      }
    };
    t6 = [wrapperRef];
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[11] !== maxOffset2 || $[12] !== translate) {
    t7 = () => {
      if (translate === -maxOffset2) {
        setRotaten(6);
      }
      if (translate === -(wrapperRef?.current?.getBoundingClientRect().width * 0.2)) {
        setRotaten(3);
      }
      if (translate === -maxOffset2 + wrapperRef?.current?.getBoundingClientRect().width * 0.2) {
        setRotaten(0);
      }
      if (translate >= 0) {
        setRotaten(-6);
      }
    };
    t8 = [translate, maxOffset2];
    $[11] = maxOffset2;
    $[12] = translate;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  useEffect(t7, t8);
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = classNames(style.horizontalScrollContainer, "horizontal");
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isMobile || $[17] !== rotateN || $[18] !== translate) {
    t10 = scrollLocation && <div className={style.horizontalScrollWrapper} style={{
      "--translate": `${translate}px`
    }} ref={wrapperRef}>{scrollLocation.map(item => <div key={item.id} ref={activeRef} className={classNames(style.horizontalScrollItem, item.style)} style={{
        transform: item.rotate > 0 ? `rotate(${item.rotate + rotateN}deg)` : `rotate(${item.rotate - rotateN}deg)`,
        top: `${item.top}%`
      }}><div className={style.itemInner}><ParallaxMedia onMove={true} src={item.src} src375={item.srcXS} className={style.horizontalScrollImg} /><SafeHtmlRenderer className={style.horizontalScrollImgTitle} tag="div" content={item.text || ""} /></div><NextImage loading="lazy" decoding="async" src={!isMobile ? Gradient_5 : Gradient_4_mob} alt="gradient" className={style.horizontalScrollImgGradient} /></div>)}</div>;
    $[16] = isMobile;
    $[17] = rotateN;
    $[18] = translate;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <button className={style.swiperButtonNext} ref={cursorNext}><NextImage src={SVGrRight} alt="SVGrRight" className={style.swiperButtonIconNext} /></button>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <button className={style.swiperButtonPrev} ref={cursorPrev}><NextImage src={SVGrRight} alt="SVGrRight" className={style.swiperButtonIconPrev} /></button>;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = classNames("buttonWrapperPrev", style.buttonWrapperPrev);
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  let t15;
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => showCursor(cursorPrev);
    t15 = () => hideCursor(cursorPrev);
    t16 = e_0 => moveCursor(e_0, cursorPrev);
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t14 = $[23];
    t15 = $[24];
    t16 = $[25];
  }
  let t17;
  if ($[26] !== GoToRight) {
    t17 = <div className={t13} ref={wrapperPrevRef} onMouseEnter={t14} onMouseLeave={t15} onMouseMove={t16} onClick={GoToRight} role="button" tabIndex="0" />;
    $[26] = GoToRight;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = classNames("buttonWrapperNext", style.buttonWrapperNext);
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  let t20;
  let t21;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => showCursor(cursorNext);
    t20 = () => hideCursor(cursorNext);
    t21 = e_1 => moveCursor(e_1, cursorNext);
    $[29] = t19;
    $[30] = t20;
    $[31] = t21;
  } else {
    t19 = $[29];
    t20 = $[30];
    t21 = $[31];
  }
  let t22;
  if ($[32] !== GoToLeft) {
    t22 = <div className={t18} ref={wrapperNextRef} onMouseEnter={t19} onMouseLeave={t20} onMouseMove={t21} onClick={GoToLeft} role="button" tabIndex="0" />;
    $[32] = GoToLeft;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== t17 || $[35] !== t22) {
    t23 = <div className={style.buttonContainer}>{t17}{t22}</div>;
    $[34] = t17;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== t10 || $[38] !== t23) {
    t24 = <div className={t9} ref={scrollRef}>{t10}{t11}{t12}{t23}</div>;
    $[37] = t10;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  return t24;
}
function _temp2(cursorRef_1) {
  if (cursorRef_1.current) {
    cursorRef_1.current.style.opacity = "0";
  }
}
function _temp(cursorRef_0) {
  if (cursorRef_0.current) {
    cursorRef_0.current.style.opacity = "1";
  }
}
export default SliderLocation;